

namespace Gordic.Epk.WebControls {

    /**
     * Dialog doplnění IxsDpo na základě kategorie důvodu podpisu 
     * ref T29860
     * 
     * @author thazmuka
     * @since 490.1.0.28
     */
    export class AddIxsDpoDlg {

        private cnt: GContentType<any>;
        constructor(cnt: GContentType<any>) {
            this.cnt = cnt;
        }

        public run(ixsDpo: string, ktgDpoSupportDbParamsDto: GKtgDpoSupportDbParamsDto) {

            const dfd = $.Deferred();

            if (ixsDpo != null && ixsDpo !== "") {
                console.info("EpkSettlement: IxsDpo is filled.");
                return dfd.resolve().promise();
            }

            if (ktgDpoSupportDbParamsDto == null || ktgDpoSupportDbParamsDto.gin_sgn_ktgdp === 0) {
                console.info("EpkSettlement: GinSgnKtgdp is false.");
                return dfd.resolve().promise();
            }

            // Podepsání úkonu v EPK (kval. certifikátem) - hodnota 80, který bude zadán napevno v kódu a nebude se měnit
            const ktgDuvPodp = Gordic.Gin.Globals.Enums.KtgDuvPodp.podpisUkonuEpkCertifikat;
            const ktgDpoSupport = new GKtgDpoSupport(this.cnt, ktgDpoSupportDbParamsDto);
            ktgDpoSupport.SetZobrazitVyberDuvoduVzdy(true);

            console.info("EpkSettlement: IxsDpo is propably empty.");

            ktgDpoSupport.Init(ktgDuvPodp, true)
                .then(function (data) {
                    dfd.resolve(data.IxsDpo);
                }, (reason: { ErrMsg: string }) => {
                    const reasonResponse: IGReasonResponse = {
                        handled: false,
                        operation: "ktgDpo",
                        reason: reason.ErrMsg,
                        type: 3
                    };
                    dfd.reject(reasonResponse);
                })

            return dfd.promise();
        }

    }

}